import React, { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import Card from '../../../../components/Card/Card';
import AcceptanceTable from './AcceptanceTable';
import getAcceptanceIssues from '../../../../thunks/coilovers/acceptance/getAcceptanceIssues';

const containerClassName = '';
const tableContainerClassName = 'overflow-auto';

const AcceptanceIssues = ({ onDelivered }) => {
  const dispatch = useDispatch();
  const {
    getAcceptanceIssues: {
      loading, data
    }
  } = useSelector((state) => ({
    getAcceptanceIssues: state?.getAcceptanceIssues
  }), shallowEqual);

  useEffect(() => {
    if (!data?.length) {
      dispatch(getAcceptanceIssues());
    }
  }, []);

  return (
    <Card
      showHeader
      headerTitle="Issues"
      headerBordered={false}
      footerBordered={false}
      styleContainer={containerClassName}
    >
      <div className={tableContainerClassName}>
        <AcceptanceTable
          data={data}
          loading={loading}
          onDelivered={onDelivered}
        />
      </div>
    </Card>
  );
};

AcceptanceIssues.propTypes = {
  onDelivered: PropTypes.func
};

AcceptanceIssues.defaultProps = {
  onDelivered: () => {}
};
export default AcceptanceIssues;
